
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ComponentExample, ComplexityLevel } from "@/types/estimation-types";

interface ComponentExamplesProps {
  examples: ComponentExample[];
  selectedComplexity: ComplexityLevel | "";
  onSelectComplexity: (complexity: ComplexityLevel) => void;
}

export const ComponentExamples: React.FC<ComponentExamplesProps> = ({
  examples,
  selectedComplexity,
  onSelectComplexity,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {examples.map((example) => (
        <Card
          key={example.complexity}
          className={`cursor-pointer transition-all hover:shadow-md ${
            selectedComplexity === example.complexity
              ? "border-blue-500 shadow-sm ring-1 ring-blue-500"
              : "border-blue-100 dark:border-blue-800"
          }`}
          onClick={() => onSelectComplexity(example.complexity)}
        >
          <CardContent className="p-4">
            <div className="flex justify-between items-start mb-2">
              <h4 className="font-medium text-blue-800 dark:text-blue-300">{example.complexity}</h4>
              {selectedComplexity === example.complexity && (
                <div className="bg-blue-600 text-white text-xs px-2 py-1 rounded">
                  Selected
                </div>
              )}
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">{example.description}</p>
            <p className="text-sm italic text-blue-700 dark:text-blue-400">Example: {example.example}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
